<template>
    <main>
        <div class="main">
            <dl class="titleTip">
                <dt>成员单位</dt>
                <dd></dd>
           </dl>
           <dl class="mainBox">
             <div class="item_box"  v-for="item in list" @click="goSectionIntroductionDetail(item.id)">
               <img :src="item.indexImg" alt="">
               <div>
                  <div class="title">{{item.name}}</div>
                  <div>
                    <div class="my_content">单位介绍:</div>
                    <div class="my_content" style="height: 120px;overflow: hidden;display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;">{{item.introduce ? item.introduce : '暂无单位介绍'}}</div>
                  </div>
               </div>
             </div>
            </dl>
        </div>
    </main>
</template>
<script>
    export default {
        name: 'SectionIntroduction',
        created() {
            this.getSectionIntroduction();
        },
        data() {
            return {
              list: []
            }
        },
        methods: {
            goSectionIntroductionDetail (id) {
              this.$router.push({path: '/SectionIntroductionDetail?id=' + id})
            },
            getSectionIntroduction() {
                this.$api.getMemberList().then(r => {
                    if (r.code === 1) {
                      this.list = r.data.data
                    }
                })
            },
        },
    }

</script>
<style lang="scss" scoped>
    @import './SectionIntroduction.scss';
</style>
